const SvgIcon = ({ path, viewBox = '0 0 24 24', size = 20, fill = 'currentColor', style, title, ...props }) => {
    const ariaLabel = props['aria-label'];
    const informational = !!(ariaLabel || title);
    const a11yProps = informational
        ? { role: 'img', 'aria-label': ariaLabel }
        : { 'aria-hidden': 'true', focusable: 'false' };
    return (
        <svg
            viewBox={viewBox}
            width={size}
            height={size}
            fill={fill}
            style={style}
            {...a11yProps}
            {...props}
        >
            {title && <title>{title}</title>}
            <path d={path} />
        </svg>
    );
};

export const PhoneIcon = ({ size = 20, ...props }) => (
    <SvgIcon
        path="M1600 1240q0 27-10 70.5t-21 68.5q-21 50-122 106-94 51-186 51-27 0-52.5-3.5t-57.5-12.5-47.5-14.5-55.5-20.5-49-18q-98-35-175-83-128-79-264.5-215.5t-215.5-264.5q-48-77-83-175-3-9-18-49t-20.5-55.5-14.5-47.5-12.5-57.5-3.5-52.5q0-92 51-186 56-101 106-122 25-11 68.5-21t70.5-10q14 0 21 3 18 6 53 76 11 19 30 54t35 63.5 31 53.5q3 4 17.5 25t21.5 35.5 7 28.5q0 20-28.5 50t-62 55-62 53-28.5 46q0 9 5 22.5t8.5 20.5 14 24 11.5 19q76 137 174 235t235 174q2 1 19 11.5t24 14 20.5 8.5 22.5 5q18 0 46-28.5t53-62 55-62 50-28.5q14 0 28.5 7t35.5 21.5 25 17.5q25 15 53.5 31t63.5 35 54 30q70 35 76 53 3 7 3 21z"
        viewBox="192 0 1408 1792"
        size={size}
        {...props}
    />
);

export const CheckmarkIcon = ({ size = 20, ...props }) => (
    <SvgIcon
        path="M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
        viewBox="192 0 1550 1792"
        size={size}
        {...props}
    />
);

export const UserIcon = ({ size = 16, fill = '#494949', ...props }) => (
    <SvgIcon
        path="M1600 1405q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q9 0 42 21.5t74.5 48 108 48 133.5 21.5 133.5-21.5 108-48 74.5-48 42-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zm-320-893q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
        viewBox="192 0 1408 1792"
        size={size}
        fill={fill}
        {...props}
    />
);

export const ExpandMoreIcon = ({ size = 24, ...props }) => (
    <SvgIcon
        path="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
        size={size}
        {...props}
    />
);

export const VisibilityIcon = ({ size = 20, ...props }) => (
    <SvgIcon
        path="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
        size={size}
        {...props}
    />
);

export const VisibilityOffIcon = ({ size = 20, ...props }) => (
    <SvgIcon
        path="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C11.74 7.13 12.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
        size={size}
        {...props}
    />
);

export default SvgIcon;
